import { render } from "./imageWorkDetail.vue?vue&type=template&id=149af1c4&scoped=true"
import script from "./imageWorkDetail.vue?vue&type=script&lang=js"
export * from "./imageWorkDetail.vue?vue&type=script&lang=js"

import "./imageWorkDetail.vue?vue&type=style&index=0&id=149af1c4&lang=less&scoped=true"
import "./imageWorkDetail.vue?vue&type=style&index=1&id=149af1c4&lang=css"

import exportComponent from "D:\\benq\\dev-front\\design-competition\\2021\\design-competition-web-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-149af1c4"]])

export default __exports__